module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/1/5-7031dc6cbfc34e5155e6d57a09e8e85a.jpg";